import { get, filter, flatten, find, findIndex, reject, times } from 'lodash';

import { numberWithLessDecimals } from 'hb-react/shared/utils/formatNumber';

export const getGiftIndex = ({ selectedGifts, fundId }) =>
  findIndex(selectedGifts, (gift) => gift.fund_id == fundId);

export const getEqualAmounts = ({ totalAmount, giftCount }) => {
  if (giftCount == 0) {
    return [];
  }
  if (giftCount == 1) {
    return [Number(numberWithLessDecimals(totalAmount)) || 0];
  }

  const normalAmount = Math.floor(totalAmount / giftCount);
  const lastAmount = Number(
    numberWithLessDecimals(normalAmount + (totalAmount % giftCount)),
  );

  const amounts = times(giftCount - 1, () => normalAmount);

  amounts.push(lastAmount);

  return amounts;
};

export const getTotalGiftsAmount = (gifts) => {
  let total = 0;

  gifts.forEach((gift) => {
    if (gift.amount) {
      total += Number(gift.amount);
    }
  });

  return total;
};

export const getFundsForOneCategory = ({ funds, category }) =>
  filter(funds, (fund) => get(fund, ['category', 'id']) == category.id) || [];

export const getFundsWithoutHightlight = ({ funds }) =>
  filter(funds, (fund) => !fund.highlight);

export const getRemainingFunds = ({ allSelectedFunds, funds }) =>
  reject(funds, (fund) =>
    find(
      flatten(allSelectedFunds),
      (selectedFund) => selectedFund.id == fund.id,
    ),
  );

export const getCategorizedFunds = ({ funds, categories }) => {
  const results = [];
  const allSelectedFunds = [];
  const fundsWithoutHighlight = getFundsWithoutHightlight({ funds });

  categories.forEach((category) => {
    const selectedFunds = getFundsForOneCategory({
      funds: fundsWithoutHighlight,
      category,
    });

    if (selectedFunds.length > 0) {
      allSelectedFunds.push(selectedFunds);
      results.push({
        id: category.id,
        name: category.name,
        funds: selectedFunds,
      });
    }
  });

  const remainingFunds = getRemainingFunds({
    allSelectedFunds,
    funds: fundsWithoutHighlight,
  });

  if (remainingFunds.length > 0) {
    results.push({
      id: 'other',
      name: results.length > 0 ? __('Other funds') : __('All funds'),
      funds: remainingFunds,
    });
  }

  return results;
};

export const getHighlightedFunds = ({ funds }) =>
  filter(funds, (fund) => fund.highlight);
